import { render, staticRenderFns } from "./paymentReceivedEditDialog.vue?vue&type=template&id=a630463e&scoped=true&"
import script from "./paymentReceivedEditDialog.vue?vue&type=script&lang=js&"
export * from "./paymentReceivedEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a630463e",
  null
  
)

export default component.exports